/**
 * Labstep
 *
 * @module components/Entity/TimeMachine/List
 * @desc List of entities loaded for the time machine
 */

import { CommentItemContainer } from 'labstep-web/components/Comment/Item';
import { TableCard } from 'labstep-web/components/Table/Card';
import { ReadOnMountHOC } from 'labstep-web/hoc/ReadOnMount';
import { Comment } from 'labstep-web/models/comment.model';
import { Experiment } from 'labstep-web/models/experiment.model';
import { Protocol } from 'labstep-web/models/protocol.model';
import { ProtocolTable } from 'labstep-web/models/protocol-table.model';
import { ProseMirrorContainer as ProseMirrorReadOnly } from 'labstep-web/prosemirror/ReadOnly';
import type React from 'react';
import type { EntityTimeMachineListProps } from './types';

export const EntityTimeMachineList: React.FC<
  EntityTimeMachineListProps
> = ({ entityName, timestamp, id }) => (
  <ReadOnMountHOC
    type="entities"
    entityName={entityName}
    params={{
      id,
      at: timestamp,
      get_single: 1,
    }}
    loading={{ loader: 'main_content', cached: true }}
    children={({ entity: entityAtTimeStamp }) => {
      switch (entityName) {
        case Protocol.entityName:
        case Experiment.entityName:
          return (
            <ProseMirrorReadOnly
              initialState={entityAtTimeStamp.state}
              entity={entityAtTimeStamp}
              timestamp={timestamp}
            />
          );
        case ProtocolTable.entityName:
          return (
            <TableCard
              name={entityAtTimeStamp.name}
              data={entityAtTimeStamp.data}
              debouncingStatus={{ isFetching: false }}
              onChange={() => {}}
              onError={() => {}}
              readOnly
            />
          );
        case Comment.entityName:
          return (
            <CommentItemContainer
              comment={entityAtTimeStamp}
              readOnly
            />
          );
        default:
          return null;
      }
    }}
  />
);
